export default function Stats({ numItems, packedItems }) {
  const packedPercent = Math.round((packedItems * 100) / numItems);
  return (
    <footer className="stats">
      {numItems === 0 ? (
        <>You have no added items to your check list</>
      ) : packedPercent === 100 ? (
        <>You are ready for your 🌴Travel✈️</>
      ) : (
        <>
          You have {numItems} items in your list. You have packed {packedItems}{" "}
          items of them{packedPercent}%
        </>
      )}
    </footer>
    //packedPercent!==100
  );
}
